import React, { useState, useEffect, useRef } from "react";
import StateApi from "./../ApiCalls/StateApi";
import AreaApi from './../ApiCalls/AreaApi';
import SchemeApi from './../ApiCalls/SchemeApi';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Radio, RadioGroup, FormControlLabel } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import axios from 'axios';



const QueryBoxModal = (props) => {

  const [stateSelectionV1, setStateSelectionV1] = useState();
  const [selectedStateV1, setSelectedStateV1] = useState();
  const [isStateSelectedV1, setIsStateSelectedV1] = useState(false);
  const [areaSelectionV1, setAreaSelectionV1] = useState();
  const [selectedAreaV1, setSelectedAreaV1] = useState();
  const [isAreaSelectedV1, setIsAreaSelectedV1] = useState(false);
  const [changeArea, setChangeArea] = useState(true);

  let areaId = props.areaId;
  let setAreaId = props.setAreaId;
  let stateId = props.stateId;
  let setStateId = props.setStateId;
  let setIsModalOpen = props.setIsModalOpen;

  return (
    <div
      className="styled-div_area"
      style={{ width: '80%', minHeight: '46px', display: 'flex', alignItems: 'center', position: 'absolute', top: '66px', left: '36px' }}
      onClick={() => {
        setIsModalOpen(true)
      }}
    >
      {(areaId && areaId.name != 'State Level Data') && areaId.name} {(areaId && areaId.name != 'State Level Data') && `,`} {stateId && stateId.name}
    </div>
  );
}

export default QueryBoxModal;